import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["statusInput", "tabButton", "panel"]

  connect() {
    this.selectTab("julgado")
  }

  julgado() {
    this.statusInputTarget.value = "julgado"
    this.selectTab("julgado")
  }

  vista() {
    this.statusInputTarget.value = "pedido_vista"
    this.selectTab("vista")
  }

  adiado() {
    this.statusInputTarget.value = "adiado"
    this.selectTab("adiado")
  }

  retirado_pauta() {
    this.statusInputTarget.value = "retirado_pauta"
    this.selectTab("retirado_pauta")
  }

  selectTab(name) {
    this.tabButtonTargets.forEach(btn => {
      const isActive = btn.dataset.tab === name
      btn.classList.toggle("bg-primary-50", isActive)
      btn.classList.toggle("text-primary-700", isActive)
      btn.classList.toggle("font-medium", isActive)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tab !== name)
    })
  }
}
